import $ from 'jquery';
import 'jquery-ui';

window.$ = $;
window.jQuery = $;
window.$ = $.extend(require('jquery-ui'));
